import moment from 'moment';
export default {
  getOnlyDateByText(text) {
    var momentDate = moment(text);
    return momentDate.toDate();
  },
  valueIsDate(value) {
    if(isNaN(value) && !isNaN(Date.parse(value)))
        return true;
    else return false;
  },
  maskDateLocal(value, onlyDate) {    
    if (value.length == 2) return value.replace(/^(\d{2})*/, '$1/');
    if (value.length == 4) return value.replace(/^(\d{2})(\d{2})*/, '$1/$2/');
    if (value.length == 8) return value.replace(/^(\d{2})(\d{2})(\d{4})*/, onlyDate ? '$1/$2/$3' : '$1/$2/$3 ');
    if (value.length == 10) return value.replace(/^(\d{2})(\d{2})(\d{4})(\d{2})*/, '$1/$2/$3 $4:');
    if (value.length == 12) return value.replace(/^(\d{2})(\d{2})(\d{4})(\d{2})(\d{2})*/, '$1/$2/$3 $4:$5:');
    if (value.length == 14) return value.replace(/^(\d{2})(\d{2})(\d{4})(\d{2})(\d{2})(\d{2})*/, '$1/$2/$3 $4:$5:$6');
  }
};
